<template>
<div class="lang-menu">
    <button class="lang-menu__toggle" @click="onShowMenu">
        {{tm('Language')}}
        <svg version="1.1" baseProfile="tiny" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" viewBox="0 0 32 20">
            <path fill="#ffffff99" d="M28.9,4.2h-8.4c-1.7,0-3.1,1.4-3.1,3.1v8.4c0,0.1-1.6,4-1.6,4l4.7-0.9c0,0,0,0,0,0h8.4
                c1.7,0,3.1-1.4,3.1-3.1V7.3C32,5.6,30.6,4.2,28.9,4.2z M29.1,9.1c0,2.1-1,4-2.6,5.3c0.8,0.2,1.7,0.4,2.6,0.3v1.6
                c-1.5,0-2.9-0.3-4.3-0.8c-1.2,0.6-2.5,0.8-3.8,0.8v-1.6c0.7,0,1.4-0.1,2-0.3c-1.2-1-2-2.3-2-3.7h1.6c0,1.2,0.8,2.2,2.1,3
                c1.6-1,2.6-2.7,2.7-4.6H21V7.5h3.2V5.9h1.6v1.6h3.2V9.1z"/>
            <polygon fill="#FFFFFF" points="6.4,8.4 9.3,8.4 7.9,5.1 "/>
            <path fill="#FFFFFF" d="M13.7,0H2.2C1,0,0,1,0,2.2v10.5c0,1.2,1,2.2,2.2,2.2h3.5l5.7,3.6v-3.6h2.4c1.2,0,2.2-1,2.2-2.2V2.2
                C15.8,1,14.9,0,13.7,0z M12.2,12.2c-0.2,0.2-0.4,0.2-0.6,0.2c-0.2,0-0.3-0.1-0.5-0.2c-0.1-0.1-0.2-0.2-0.3-0.4L10,10.1H5.7L5,11.8
                c-0.1,0.2-0.2,0.3-0.3,0.4c-0.1,0.1-0.3,0.2-0.5,0.2c-0.3,0-0.5-0.1-0.6-0.2c-0.1-0.1-0.2-0.3-0.2-0.5c0-0.1,0-0.2,0-0.3l3.6-8.6
                c0.1-0.2,0.2-0.3,0.4-0.4C7.6,2.3,7.8,2.2,8,2.3c0.2,0,0.3,0.1,0.5,0.2c0.1,0.1,0.3,0.2,0.3,0.4l3.6,8.4c0,0.1,0.1,0.2,0.1,0.3
                C12.4,11.8,12.3,12,12.2,12.2z"/>
        </svg>
    </button>
    <div v-if="showMenu" class="lang-menu__options" @click.stop="onHideMenu">
        <button v-for="loc in allLocales" :key="loc.id" @click="onChangeLang(loc.code)">{{loc.name}}</button>
    </div>
</div>
</template>
    
<script>
import { getAllLocales } from '@/i18n'
export default {
    name: 'MenuLang',
    props: ['i18n'],
    data () {
        return {
            showMenu: false
        }
    },
    computed: {
        'allLocales': () => getAllLocales()
    },
    methods: {
        'tm': function (message) {
            if ('i18n' in this && typeof this.i18n == 'function') {
                return this.i18n(message)
            }
            return message
        },
        'onShowMenu': function () {
            this.showMenu = true
        },
        'onHideMenu': function () {
            this.showMenu = false
        },
        'onChangeLang': function (lang) {
            this.$emit('onChangeLanguage', lang)
        }
    }
}
</script>
    
<style lang="scss" scoped>
    .lang-menu {
        position: relative;
        display: inline-flex;
        align-items: center;
        padding: 0;
        border-radius: 18px;
        transition: background-color .4s;

        &:hover {
            background-color: rgba(0, 0, 0, .1);
        }

        .lang-menu__toggle {
            display: flex;
            align-items: center;
            padding: 4px 10px;
            font-weight: bold;
            text-shadow: 0 1px 0 rgba(0,0,0,.3);
            color: white;

            svg {
                height: 22px;
                margin-left: 8px;;
            }
        }

        .lang-menu__options {
            position: absolute;
            top: 15px;
            right: 15px;
            display: flex;
            flex-direction: column;
            background-color: white;
            box-shadow: 0 5px 25px rgba(0, 0, 0, 0.12);
            z-index: 999;

            &:after {
                content: '';
                position: fixed;
                top: -100vh;
                left: 0;
                width: 100vw;
                height: 200vh;
                z-index: 5;
            }

            button {
                position: relative;
                padding: 10px 24px;
                font-size: .9em;
                cursor: pointer;
                z-index: 10;
            }
            button+button {
                border-top: 1px solid #eee;
            }
            button:hover {
                font-weight: bold;
                /* background-color: var(--colorVeryLight); */
            }
        }

    }
</style>